import { useState, useEffect } from "react";
import { MobileMenu } from "../MenuLateral/MobileMenu";
import { MenuBurguer } from "@/assets/images/Icons";
import { useLayout } from "@/contexts/UseLayout";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronLeft, ChevronRight, Home } from "lucide-react";
import {
  hasAdLinkAccess,
  hasGoOnAccess,
} from "@/components/utils/NiveisDeAcesso";
import { getPageTitle } from "./getPageTitle";
import { navigationStack } from "./navigationStack";

export default function HeaderDash() {
  const [openMenuMobile, setOpenMenuMobile] = useState(false);
  const { userLogged } = useLayout();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title, parent, parentPath } = getPageTitle(pathname);

  useEffect(() => {
    navigationStack.push(pathname);
  }, [pathname]);

  const handleBack = () => {
    if (navigationStack.canGoBack()) {
      const previous = navigationStack.pop();
      navigate(previous, { replace: true });
    } else {
      navigate("/overview", { replace: true });
    }
  };

  const hasAccessToBothViews =
    hasGoOnAccess(userLogged) && hasAdLinkAccess(userLogged);

  const handleToggleToAdLink = () => {
    navigate("/ad-link");
  };

  const canGoBack = navigationStack.canGoBack();

  return (
    <div className="bg-cinza-100 py-2">
      <div className="flex items-center justify-between">
        {/* Mobile: menu hamburguer */}
        <button
          className="md:hidden p-4"
          onClick={() => setOpenMenuMobile(true)}
        >
          <MenuBurguer />
        </button>

        {/* Breadcrumb / Navegação contextual */}
        <nav
          className="hidden md:flex items-center gap-1 text-sm"
          aria-label="Breadcrumb"
        >
          {/* Home link */}
          <button
            onClick={() => navigate("/overview")}
            className="flex items-center gap-1 text-cinza-400 hover:text-azul-400 transition-colors rounded-lg px-2 py-1.5 hover:bg-white/60"
          >
            <Home size={14} />
            <span>Início</span>
          </button>

          {/* Se tem parent (2 níveis) */}
          {parent ? (
            <>
              <ChevronRight size={14} className="text-cinza-300 shrink-0" />
              <button
                onClick={() => parentPath && navigate(parentPath)}
                className="text-cinza-400 hover:text-azul-400 transition-colors rounded-lg px-2 py-1.5 hover:bg-white/60"
              >
                {parent}
              </button>
              <ChevronRight size={14} className="text-cinza-300 shrink-0" />
              <span className="font-medium text-cinza-800 px-2 py-1.5">
                {title}
              </span>
            </>
          ) : title ? (
            <>
              <ChevronRight size={14} className="text-cinza-300 shrink-0" />
              <span className="font-medium text-cinza-800 px-2 py-1.5">
                {title}
              </span>
            </>
          ) : null}
        </nav>

        {/* Mobile: breadcrumb compacto */}
        {title ? (
          <div className="flex md:hidden items-center gap-1.5 flex-1 min-w-0 px-1">
            {canGoBack && (
              <button
                onClick={handleBack}
                className="flex items-center justify-center w-8 h-8 shrink-0 rounded-lg text-cinza-400 hover:text-cinza-800 hover:bg-white/60 transition-colors"
                aria-label="Voltar"
              >
                <ChevronLeft size={18} />
              </button>
            )}
            <div className="flex items-center gap-1 min-w-0 text-sm">
              {parent && (
                <>
                  <span className="text-cinza-400 truncate">{parent}</span>
                  <ChevronRight size={12} className="text-cinza-300 shrink-0" />
                </>
              )}
              <span className="font-medium text-cinza-800 truncate">
                {title}
              </span>
            </div>
          </div>
        ) : null}

        {/* Botão Ad-Link - Mobile */}
        {hasAccessToBothViews && (
          <button
            onClick={handleToggleToAdLink}
            className="md:hidden mr-4 bg-gradient-to-r from-azul-400 to-azul-600 text-white rounded-full py-2 px-4 shadow-md hover:shadow-lg transition-all flex items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
            <span className="text-xs font-medium">Ad-Link</span>
          </button>
        )}
      </div>

      {openMenuMobile && <MobileMenu togleModal={setOpenMenuMobile} />}
    </div>
  );
}
